import './userLog.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState, useRef } from 'react';
import dbService from '../../services/database';
import { FaArrowLeft } from 'react-icons/fa';

const UserLog = () => {
  const location = useLocation();
  const transaction = location.state?.transaction;
  const [inputter, setInputter] = useState(null);
  const [reason, setReason] = useState(transaction?.reason);
  const isMounted = useRef(true);

  const navigate = useNavigate();

  useEffect(() => {
    isMounted.current = true;

    const fetchInputterData = async () => {
      if (transaction?.inputter && !inputter) {
        try {
          const staffData = await dbService.getStaffById(transaction.inputter);
          if (staffData && isMounted.current) {
            setInputter(staffData.name || staffData.display_name);
          }
        } catch (error) {
          console.error('Error fetching staff:', error);
        }
      }
    };

    const fetchTransferReason = async () => {
      if (
        transaction?.type === 'transfer' &&
        reason === undefined &&
        transaction.transferId
      ) {
        try {
          // For now, use the reason from transaction itself since transfers table methods don't exist yet
          if (transaction.reason) {
            setReason(transaction.reason);
          } else {
            setReason('Transfer - reason not available');
          }
        } catch (error) {
          console.error('Error fetching transfer reason:', error);
          if (transaction.reason) {
            setReason(transaction.reason);
          }
        }
      }
    };

    fetchInputterData();
    fetchTransferReason();

    return () => {
      isMounted.current = false;
    };
  }, [transaction, reason, inputter]);

  if (!transaction) return null;

  const isDividend = transaction.type === 'dividend';

  return (
    <div className="user-log">
      <button className="backArrow" onClick={() => navigate(-1)}>
        <FaArrowLeft />
      </button>
      <h3>{isDividend ? 'Dividend Payment Log' : 'Transaction Log'}</h3>
      <div className={`log-details ${isDividend ? 'dividend-log' : ''}`}>
        <p>
          <strong>Date:</strong> {transaction.formattedDate}
        </p>
        <p>
          <strong>Time:</strong> {transaction.formattedTime}
        </p>
        <p>
          <strong>Type:</strong>{' '}
          {isDividend
            ? 'Dividend'
            : transaction.type === 'transfer'
            ? 'Transfer'
            : 'Purchase'}
        </p>
        <p>
          <strong>Details:</strong>{' '}
          {transaction.details ||
            (transaction.type === 'transfer' ? 'Transfer' : 'Purchase')}
        </p>

        {isDividend ? (
          // Dividend-specific fields
          <>
            <p>
              <strong>Share Value:</strong> GH₵{' '}
              {Number(transaction.shareValue).toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </p>
            <p>
              <strong>Dividend Amount:</strong> GH₵{' '}
              {Number(transaction.dividendAmount).toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </p>
            <p>
              <strong>Year:</strong> {transaction.year}
            </p>
            <p>
              <strong>Status:</strong>{' '}
              <span className={`status ${transaction.status}`}>
                {transaction.status}
              </span>
            </p>
          </>
        ) : (
          // Regular transaction fields
          <>
            <p>
              <strong>Balance B/f (Shares):</strong>{' '}
              {Number(transaction.totalShares) -
                Number(transaction.sharesAdded)}{' '}
              shares
            </p>
            <p>
              <strong>Balance B/f (Amount):</strong> GH₵{' '}
              {Number(transaction.totalPrice) - Number(transaction.priceAdded)}
            </p>
            <p>
              <strong>Shares Added:</strong> {transaction.sharesAdded || '-'}
            </p>
            <p>
              <strong>Amount Added:</strong>{' '}
              {transaction.priceAdded ? `GH₵ ${transaction.priceAdded}` : '-'}
            </p>
            <p>
              <strong>Balance A/c (Shares):</strong> {transaction.totalShares}{' '}
              shares
            </p>
            <p>
              <strong>Balance A/c (Amount):</strong> GH₵{' '}
              {transaction.totalPrice}
            </p>
            {transaction.type === 'transfer' && (
              <p>
                <strong>Reason for Transfer:</strong> {reason}
              </p>
            )}
          </>
        )}

        {/* Common fields for both types */}
        {transaction.processedBy && (
          <p>
            <strong>Processed By:</strong> {transaction.processedBy}
          </p>
        )}
        {inputter && (
          <p>
            <strong>Inputter:</strong> {inputter}
          </p>
        )}
      </div>
    </div>
  );
};

export default UserLog;
